import React from 'react';
import { Lightbulb } from 'lucide-react';

export function HelpBestPractices() {
  return (
    <section>
      <div className="flex items-center gap-2 mb-4">
        <Lightbulb className="w-5 h-5 text-amber-500" />
        <h3 className="text-lg font-medium text-slate-900 dark:text-slate-100">Best Practices</h3>
      </div>
      
      <div className="space-y-3">
        <div className="p-4 rounded-xl border border-amber-200/60 dark:border-amber-500/20 bg-amber-100/60 dark:bg-amber-500/5">
          <ul className="space-y-3 text-sm text-slate-800 dark:text-slate-300">
            <li className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-1.5 shrink-0" />
              <span><strong>Organizing with Workspaces:</strong> Workspaces are ideal when you have multiple tech stacks or varying career goals. We recommend creating a separate workspace for each path (e.g., "Frontend Developer" vs. "UX Designer"). This helps keep your resumes and job descriptions neatly isolated.</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
